import { render, staticRenderFns } from "./LengthOfWordAnalyse.vue?vue&type=template&id=853fe366&"
import script from "./LengthOfWordAnalyse.vue?vue&type=script&lang=js&"
export * from "./LengthOfWordAnalyse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports